<div elementDataTest="subtitlesListElement">
    <div *ngIf="subtitles.controls?.length > 0" class="text-s font-semi-bold text-grey-v6" [style.margin-bottom.rem]="0.563" translate>
        v3-upload-subtitles-desc
    </div>

    <div class="item" *ngFor="let controls of subtitles.controls; let index = index">
        <app-upload-subtitles-item [subtitlesControls]="controls" [index]="index" (removeSubtitles)="removeSubtitles($event)"></app-upload-subtitles-item>
    </div>

    <div *ngIf="canAddNewSubtitles" class="theme-new add-subtitles-btn-box">
        <button class="btn btn-secondary btn-reverse px-2 text-s font-bold btn-add-subtitles" (click)="addNewSubtitles()" translate>
            v3-upload-subtitles-add-subtitles-btn
        </button>
    </div>
</div>
